
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.955.16c.548.06 1.094.136 1.637.23L53.65 22.625c.09.544.161 1.091.217 1.64L29.955.16zM25.321.05a27.17 27.17 0 011.36-.05L54 27.54c-.009.453-.03.906-.06 1.36L25.32.05zM21.337.595c.394-.084.789-.16 1.186-.226l31.075 31.326c-.07.397-.148.791-.235 1.184L21.337.595zM17.811 1.601c.35-.126.702-.245 1.056-.356l33.826 34.1c-.114.352-.236.703-.365 1.052L17.811 1.601zM14.65 2.977c.315-.161.63-.316.95-.464l35.8 36.089c-.151.317-.309.632-.472.945L14.65 2.977zM11.805 4.67c.283-.193.567-.38.855-.56l37.118 37.418c-.183.287-.371.57-.566.85L11.805 4.67zM9.245 6.65c.253-.221.51-.437.768-.647L47.864 44.16c-.212.258-.43.512-.652.763L9.245 6.65zM6.954 8.902c.223-.247.452-.49.685-.73l38.038 38.345a27.53 27.53 0 01-.735.68L6.954 8.901zM4.932 11.424c.194-.275.394-.547.6-.815l37.692 37.996c-.27.204-.543.402-.82.594L4.932 11.424zM3.192 14.232c.164-.305.334-.607.51-.907l36.791 37.088c-.3.174-.604.342-.91.503L3.193 14.232zM1.765 17.354c.129-.339.265-.675.409-1.009L37.46 51.918c-.335.14-.672.274-1.011.4L1.765 17.355zM.698 20.84c.088-.379.184-.755.29-1.13l33.099 33.367c-.376.102-.753.196-1.131.28L.698 20.84zM.08 24.777c.035-.429.08-.856.136-1.283l30.082 30.325c-.427.052-.855.094-1.284.126L.079 24.777zM.088 29.347A27.167 27.167 0 010 27.837L25.953 54a27.074 27.074 0 01-1.508-.1L.088 29.347zM1.2 35.028c-.2-.644-.375-1.294-.526-1.95l20.044 20.206a26.923 26.923 0 01-1.945-.54L1.199 35.027zM13.13 50.196a27.068 27.068 0 01-5.232-4.087 27.058 27.058 0 01-4.197-5.418l9.43 9.505zM52.618 18.444L35.764 1.454c.783.269 1.556.574 2.317.916l13.64 13.75c.336.763.635 1.54.897 2.324z","fill":"#fff","fill-opacity":".3"}})])
          )
        }
      }
    